/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";

interface Signature {
  Args: {
    changeset: EmberChangeset;
  };
}

export default class TreatmentHistoryEditionFormBreastCancerOtherFollowUpEventsComponent extends Component<Signature> {
  get otherTypes() {
    return [
      "announcement-consultation",
      "sentinel-node-lymphoscinthigraphy",
      "ultrasound-spotting",
      "anaesthetist-consultation",
      "abdominal-ultrasound",
      "echocardiography",
      "mri",
      "mammography",
      "preoperative-nurse-appointment",
      "scanner",
      "tracking-scanner",
      "bone-scan",
      "computed-tomography",
      "smoking-cessation",
      "respiratory-cine",
      "dentist",
      "psychologist",
      "social-worker"
    ];
  }

  get events() {
    return this.args.changeset.get("otherFollowUpEvents");
  }

  @action
  onChangesetUpdate(changeset: EmberChangeset) {
    changeset.execute();
    this.setAsDirty();
  }

  setAsDirty() {
    this.args.changeset.set("otherFollowUpEvents", [].concat(this.events));
  }
}
